import script from "./SysRoleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SysRoleManagement.vue?vue&type=script&setup=true&lang=js"

import "./SysRoleManagement.vue?vue&type=style&index=0&id=26a32442&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26a32442"]])

export default __exports__